import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from "@angular/router";
import { Constants } from "../../../utils/constants";
import { InvoiceSetupService } from "../../../services/invoice-setup.service";
import { InvoiceSetup } from 'src/app/model/invoiceSetup';
import { InvoiceItems } from 'src/app/model/invoiceItems';
import { SnackService } from 'src/app/services/snack.service';
import { GeneralItemDetailDialogComponent } from 'src/app/shared-components/general-item-detail-dialog/general-item-detail-dialog.component';
import { DialogsService } from 'src/app/services/dialogs.service';
import { InvoiceSetupItemArray } from 'src/app/model/invoiceSetupItemArray';
import { AuthService } from "../../../services/auth.service";

const pdfMake = require('pdfmake/build/pdfmake.js');

var pdfFonts = require('pdfmake/build/vfs_fonts');


(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'aw-invoices-items',
  templateUrl: './invoices-items.component.html',
  styleUrls: ['./invoices-items.component.scss']
})
export class InvoicesItemsComponent {
  color = 'red';
  isPayed!: boolean;
  displayedColumns!: string[];
  checked!: boolean;
  invoiceSetup: InvoiceSetup[] = [];
  statusMessage!: string;
  saving = false;
  showEdit: boolean[] = [];
  invoiceItems: InvoiceItems[] = [];
  invoice = new InvoiceSetupItemArray();
  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
  });
  @Output() saved = new EventEmitter<void>();
  headers = [
    'idInvoice',
    'invoiceNumber',
    'company',
    'contractDescription',
    'refContract',
    'contractBoxNumbers',
    'contractType',
    'startDate',
    'endDate',
    "paid",
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  dataSource!: MatTableDataSource<InvoiceSetup>;
  panelOpenState = false;
  contractTypes = Constants.contractTypes;
  roles = Constants.roles;
  loggedUser?: any;

  constructor(
    private invoiceSetupService: InvoiceSetupService,
    private authService: AuthService,
    private snackService: SnackService,
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private router: Router,
    private dialogsService: DialogsService
  ) { }
  ngOnInit() {
    this.loggedUser = this.authService.loggedUser();

    if (this.loggedUser.role === this.roles.admin) {
      this.loadItemsInvoice();
    } else if (this.loggedUser.role === this.roles.customer) {
      this.loadItemsInvoiceByCompany();
    }
    for (let i = 0; i < this.invoiceSetup.length; i++) {
      this.showEdit[i] = false;
    }
  }

  loadItemsInvoice() {
    this.invoiceSetupService.getAllItemInvoice()
      .subscribe(res => {
        this.invoiceSetup = res;

        //console.log('this.invoiceSetup', this.invoiceSetup);
        this.dataSource = new MatTableDataSource(this.invoiceSetup);

        this.dataSource.filterPredicate = (data: any, filter) => {
          //this.dataSource.filterPredicate = (data, filter) => JSON.stringify(data).includes(filter);
          const dataStr = data.id + data.contract.company.companyName + data.contract.description + data.identifier + data.contract.numberOfBoxes + data.contract.startDate + data.contract.endDate;
          return dataStr.trim().toLowerCase().indexOf(filter) != -1;
        }

        this.dataSource.paginator = this.paginatorUsers;

      });
  }

  loadItemsInvoiceByCompany() {
    this.invoiceSetupService.getAllItemInvoiceByCompany(this.loggedUser.company.id)
      .subscribe(res => {
        this.invoiceSetup = res;

        console.log('this.invoiceSetup', this.invoiceSetup);
        this.dataSource = new MatTableDataSource(this.invoiceSetup);

        this.dataSource.filterPredicate = (data: any, filter) => {
          //this.dataSource.filterPredicate = (data, filter) => JSON.stringify(data).includes(filter);
          const dataStr = data.id + data.contract.company.companyName + data.contract.description + data.identifier + data.contract.numberOfBoxes + data.contract.startDate + data.contract.endDate;
          return dataStr.trim().toLowerCase().indexOf(filter) != -1;
        }

        this.dataSource.paginator = this.paginatorUsers;

      });
  }

  details(invoiceSetup: InvoiceSetup): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: invoiceSetup });
  }

  editSatusIsPayed(invoiceSetup: InvoiceSetup) {
    this.disabled = false;

    if (invoiceSetup.isPayed) {
      invoiceSetup.isPayed = false;
      this.isPayed = invoiceSetup.isPayed = false;


    } else {
      invoiceSetup.isPayed = true;
      this.isPayed = invoiceSetup.isPayed = true;

    }
    console.log(invoiceSetup);
    this.invoiceSetupService.updateInvoice(invoiceSetup)
      .subscribe(
        () => {
          this.saving = false;

          this.snackService.success('Contract updated!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
        });
  }

  deleteInvoiceSetup(invoiceSetup: InvoiceSetup): void {

    this.disabled = true;
    const id = invoiceSetup.id ?? -1;
    this.disabledItemId.push(id);
    console.log(this.disabledItemId.indexOf(id), 1);

    this.dataSource._updateChangeSubscription();

    this.invoiceSetupService.deleteInvoiceSetup(<number>invoiceSetup.id)
      .subscribe(() => {
        this.disabled = true;
        this.snackService.success('Invoice setup deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        const data = this.dataSource.data;
        data.splice(id, 1);
        this.dataSource.data = data;
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {

          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });
    const index = this.dataSource.data.indexOf(invoiceSetup);
    this.dataSource.data.splice(index, 1);
    this.dataSource._updateChangeSubscription();
  }

  sendNotificationForPayment(invoiceSetup: InvoiceSetupItemArray): void {

    let id = invoiceSetup.id;
    this.invoiceSetupService.sendNotificationForPayment(<number>id, invoiceSetup)
      .subscribe(() => {

        this.snackService.success('Email correctly sent.');

      })


  }

  createPDF(invoiceSetup: InvoiceSetupItemArray, contractId: number): void {
    let id = invoiceSetup.id;

    console.log('invoiceSetup', invoiceSetup);
    this.invoiceSetupService.createPDF(<number>id)
      .subscribe(() => {
        this.snackService.success('Email correctly sent.');


      })
  }

  generatePDF(invoiceSetup: InvoiceSetupItemArray) {
    let id = invoiceSetup.id;
    console.log(invoiceSetup);
    this.invoiceSetupService.createPDF(<number>id)
      .subscribe((invoiceSetups) => {
        this.invoice = invoiceSetups;
        console.log('invoice', this.invoice);

        console.log(this.invoice.invoiceSetup);
        let docDefinition = {
          content: [
            {
              text: 'WESETH',
              fontSize: 16,
              alignment: 'center',
              color: '#047886'
            },
            {
              text: 'Invoice estimation',
              fontSize: 20,
              bold: true,
              alignment: 'center',
              decoration: 'underline',
              color: 'skyblue'
            },
            {
              text: 'Customer Details',
              style: 'sectionHeader'
            },
            {
              columns: [
                [
                  // {
                  //   text: this.invoice.invoiceSetup.email,
                  //   bold:true
                  // },
                  { text: this.invoice.invoiceSetup.addressLine1 },
                  { text: this.invoice.invoiceSetup.identifier },
                  { text: this.invoice.invoiceSetup.description }
                ],
                [
                  {
                    text: this.invoice.createdBy,
                    alignment: 'right'
                  },
                  {
                    text: `Bill No : ${this.invoice.invoiceSetup.invoiceNumber}`,
                    alignment: 'right'
                  }
                ]
              ],
              defaultStyle: {
                font: "Helvetica",
              }
            },
            {
              text: 'Order Details',
              style: 'sectionHeader'
            },
            {
              table: {
                headerRows: 1,
                widths: ['*', 'auto', 'auto', 'auto'],
                body: [
                  ['Product', 'Price', 'Quantity', 'Amount'],
                  ...this.invoice.invoiceItems.map(p => ([p.description, p.unitCost, p.units, (p!.unitCost! * p!.units!).toFixed(2)])),
                  [{ text: 'Total Amount', colSpan: 3 }, {}, {}, this.invoice.invoiceItems.reduce((sum, p) => sum + (p!.units! * p!.unitCost!), 0).toFixed(2)]
                ]
              }
            },
            {
              // text: 'Additional Details',
              // style: 'sectionHeader'
            },
            {
              // text: this.invoice.invoiceSetup.country,
              // margin: [0, 0 ,0, 15]          
            },

            {
              columns: [
                // [{ qr: `${this.invoice.invoiceSetup.identifier}`, fit: '50' }],
                [{ text: 'Signature', alignment: 'right', italics: true }],
              ]
            },
            {
              text: 'Terms and Conditions',
              style: 'sectionHeader'
            },
            {
              ul: [
                'Warranty of the product will be subject to the manufacturer terms and conditions.',
                'This is a system generated invoice estimation',
              ],
            }
          ],

          styles: {
            sectionHeader: {
              bold: true,
              decoration: 'underline',
              fontSize: 14,
              margin: [0, 15, 0, 15]
            }
          }
        };
        this.snackService.success('PDF correctly create.');

        pdfMake.createPdf(docDefinition).open();

      })





  }

  updateInvoiceNumber(invoiceSetup: InvoiceSetup): void {
    this.disabled = false;
    if (invoiceSetup.id != null && invoiceSetup.id != null) {
      this.showEdit[invoiceSetup.id] = true;
    }
  }

  saveInvoiceNumber(invoiceSetup: InvoiceSetup) {
    this.disabled = false;

    if (invoiceSetup.id != null && invoiceSetup.id != null) {
      this.showEdit[invoiceSetup.id] = false;
    }
    console.log(invoiceSetup);
    this.invoiceSetupService.updateInvoice(invoiceSetup)
      .subscribe(
        () => {
          this.saving = false;

          this.snackService.success('Invoice number saved!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
        });
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  @ViewChild('paginatorItems') paginatorUsers!: MatPaginator;

  applyFilters(event: string): void {

    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortInvoices(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      if (event.active === 'idInvoice') {
        if (event.direction === 'desc') {
          return b.id as number - (a.id ? a.id : 0);
        } else {
          return a.id as number - (b.id ? b.id : 0);
        }
      }

      if (event.active === 'invoiceNumber') {
        if (event.direction === 'desc') {
          return ('' + b.invoiceNumber).localeCompare('' + a.invoiceNumber);
        } else {
          return ('' + a.invoiceNumber).localeCompare('' + b.invoiceNumber);
        }
      }

      if (event.active === 'company') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.company?.companyName).localeCompare('' + a.contract?.company?.companyName);
        } else {
          return ('' + a.contract?.company?.companyName).localeCompare('' + b.contract?.company?.companyName);
        }
      }

      if (event.active === 'contractDescription') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.description).localeCompare('' + a.contract?.description);
        } else {
          return ('' + a.contract?.description).localeCompare('' + b.contract?.description);
        }
      }

      if (event.active === 'refContract') {
        if (event.direction === 'desc') {
          return ('' + b.identifier).localeCompare('' + a.identifier);
        } else {
          return ('' + a.identifier).localeCompare('' + b.identifier);
        }
      }

      if (event.active === 'contractBoxNumbers') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.numberOfBoxes).localeCompare('' + a.contract?.numberOfBoxes);
        } else {
          return ('' + a.contract?.numberOfBoxes).localeCompare('' + b.contract?.numberOfBoxes);
        }
      }

      if (event.active === 'contractType') {
        if (event.direction === 'asc') {
          return ('' + b.contract?.thirdPartyContract).localeCompare('' + a.contract?.thirdPartyContract);
        } else {
          return ('' + a.contract?.thirdPartyContract).localeCompare('' + b.contract?.thirdPartyContract);
        }
      }

      if (event.active === 'startDate') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.startDate).localeCompare('' + a.contract?.startDate);
        } else {
          return ('' + a.contract?.startDate).localeCompare('' + b.contract?.startDate);
        }
      }

      if (event.active === 'endDate') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.endDate).localeCompare('' + a.contract?.endDate);
        } else {
          return ('' + a.contract?.endDate).localeCompare('' + b.contract?.endDate);
        }
      }

      if (event.active === 'paid') {
        if (event.direction === 'desc') {
          return ('' + b.isPayed).localeCompare('' + a.isPayed);
        } else {
          return ('' + a.isPayed).localeCompare('' + b.isPayed);
        }
      }

      return -1;


    }
    );
  }

}
